import requestStatusCodes from '../const/requestStatusCodes';
import { RequestStatuses } from '../types/RequestStatuses';

export const checkIsLoading = (...args: RequestStatuses[]) => args.some((item) => item === requestStatusCodes.pending);

export const checkIsLoaded = (...args: RequestStatuses[]) =>
  args.every((item) => item === requestStatusCodes.fulfilled);

export const checkIsError = (...args: RequestStatuses[]) => args.every((item) => item === requestStatusCodes.rejected);
